module.exports = __webpack_public_path__ + "img/menu-wulianwang-active.1ed18b33.svg";